import React, { Component } from "react";
import "./Main.css";
import DynamicGrid from "./DynamicGrid";
import SignatureCanvas from "react-signature-canvas";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";

const Settings = {
	ShowDateFilter: false,
	SortColumn: "invoice_number",
	UseTicketTypeFilter: false,
	ShowNewButton: false,
	ShowGlobalFilter: true,
};
export class UnapprovedPackingList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			PackingLists: [],
		};
		this.getData();

		this.captureSignature = this.captureSignature.bind(this);
		this.saveSignature = this.saveSignature.bind(this);
	}
	async getData() {
		const data = await fetch("PackingList/GetPackingLists", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ approved: false }),
		});
		var res = await data.json();
		this.setState({ PackingLists: res });
	}

	captureSignature(row, mechanic) {
		this.setState({ signModal: true, Mechanic: mechanic, Estimate: row["invoice_number"], PackingList: row["packing_list_id"] });
	}

	async saveSignature() {
		if (this.sigCanvas.isEmpty()) {
			alert("A signature is required.");
			return;
		}

		var dt = {
			base64Image: this.sigCanvas.toDataURL(),
			packingListId: this.state.PackingList,
			estimateNumber: this.state.Estimate,
			mechanicId: this.state.Mechanic,
		};

		await fetch("PackingList/SavePackingList", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(dt),
		});
		this.setState({ signModal: false });
		this.getData();
	}

	async openPdf(row) {
		const data = await fetch("Proposal/GetPdf", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				estimateNumber: row.invoice_number,
				isPackingList: true,
			}),
		});

		var blob = await data.text();

		var tab = window.open();
		tab.location.href = document.location.origin + "/pdfs/" + blob;
	}

	render() {
		var config = [
			{ header: "Building Name", columnName: "building_name", visible: true, typeCode: "S" },
			{ header: "Estimate #", columnName: "invoice_number", visible: true, typeCode: "S" },
			{ header: "Serial #", columnName: "serial_number", visible: true, typeCode: "S" },
			{ header: "Mechanic", columnName: "mechanic_name", visible: true, typeCode: "MECHANIC", OnChange: this.captureSignature },
			{ header: "Open PDF", columnName: "open_pdf", visible: true, OnClick: (row) => this.openPdf(row), typeCode: "ACTION", style: { minWidth: "147px" } },
		];
		return (
			<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%" }}>
				<Dialog open={this.state.signModal} fullWidth={true} maxWidth="md">
					<DialogTitle>Signature</DialogTitle>
					<DialogContent>
						<SignatureCanvas
							ref={(ref) => {
								this.sigCanvas = ref;
							}}
							penColor="black"
							canvasProps={{ width: "900", height: "400" }}></SignatureCanvas>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.saveSignature} color="primary" autoFocus>
							Save Signature
						</Button>
					</DialogActions>
				</Dialog>
				<div style={{ flex: "1 1 100%", display: "flex", overflowY: "auto" }}>
					<DynamicGrid Title="Packing Lists" Configuration={config} DataSet={this.state.PackingLists} Settings={Settings} OnRowClick={(row) => {}} />
				</div>
			</div>
		);
	}
}
